import { render, staticRenderFns } from "./PointOverviewPanel.vue?vue&type=template&id=28f7c088&"
import script from "./PointOverviewPanel.vue?vue&type=script&lang=ts&"
export * from "./PointOverviewPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports